export const calculatePoints = (grades = []) => {
  return grades.reduce(
    (totals, grade) => {
      if (grade?.excused) {
        return totals
      }

      const earned = Number(grade?.score)
      const possible = Number(grade?.assignment?.max_score)

      if (Number.isNaN(earned) || Number.isNaN(possible)) {
        return totals
      }

      return {
        earned: totals.earned + earned,
        possible: totals.possible + possible
      }
    },
    { earned: 0, possible: 0 }
  )
}

export const calculatePercent = (grades = []) => {
  const { earned, possible } = calculatePoints(grades)
  if (possible <= 0) return null
  return Math.round((earned / possible) * 10000) / 100
}

export const calculateLetterGrade = (percentage) => {
  if (percentage === null || percentage === undefined || Number.isNaN(Number(percentage))) {
    return null
  }

  const value = Number(percentage)
  if (value >= 93) return 'A'
  if (value >= 90) return 'A-'
  if (value >= 87) return 'B+'
  if (value >= 83) return 'B'
  if (value >= 80) return 'B-'
  if (value >= 77) return 'C+'
  if (value >= 73) return 'C'
  if (value >= 70) return 'C-'
  if (value >= 67) return 'D+'
  if (value >= 63) return 'D'
  if (value >= 60) return 'D-'
  return 'F'
}

export const isMissingAcademicSchema = (error) => {
  const message = `${error?.message || ''} ${error?.details || ''}`
  const code = error?.code
  return (
    code === '42P01' ||
    code === 'PGRST205' ||
    /does not exist|schema cache|could not find the table/i.test(message)
  )
}
